import { SR_API_ACTION_RESCHEDULE_TOUR } from 'api/actionTypes';

import { getSelfSchedulingPayload } from 'common/tourHelpers';

import getToursList from './getList';

export default async function rescheduleTour(
  { state, history, apiClient },
  { tourId, startDate, availableTimes, shouldSendRequestShowingAutoText },
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_RESCHEDULE_TOUR,
    state: state,
    payload: {
      tourId: tourId,
      shouldSendRequestShowingAutoText: shouldSendRequestShowingAutoText,
      ...getSelfSchedulingPayload({
        date: startDate,
        times: availableTimes,
      }),
    },
    onSuccess() {
      history.push('/tour');
    },
  });

  return getToursList({ state, history, apiClient }, { reloadTours: true });
}
